module.exports = __webpack_public_path__ + "img/compareBI_2.18f02ed0.png";